import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=f9918be2&"
import script from "./NotificationCard.vue?vue&type=script&lang=js&"
export * from "./NotificationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports